var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundGrid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 216,
    height: 216,
    viewBox: "0 0 216 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5085_866",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: -120,
    y: -120,
    width: 336,
    height: 336
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    transform: "translate(-120 -120)",
    fill: "url(#paint0_radial_5085_866)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5085_866)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5085_866)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5085_866)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.5,
    y1: -120,
    x2: 0.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 24.5,
    y1: -120,
    x2: 24.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48.5,
    y1: -120,
    x2: 48.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 72.5,
    y1: -120,
    x2: 72.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96.5,
    y1: -120,
    x2: 96.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.5,
    y1: -120,
    x2: 120.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 144.5,
    y1: -120,
    x2: 144.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.5,
    y1: -120,
    x2: 168.5,
    y2: 216,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 192.5,
    y1: -120,
    x2: 192.5,
    y2: 216,
    stroke: "#E9EAEB"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -119.5,
    y: -119.5,
    width: 335,
    height: 335,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_5085_866)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 23.5,
    x2: 216,
    y2: 23.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 47.5,
    x2: 216,
    y2: 47.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 71.5,
    x2: 216,
    y2: 71.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 95.5,
    x2: 216,
    y2: 95.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 119.5,
    x2: 216,
    y2: 119.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 143.5,
    x2: 216,
    y2: 143.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 167.5,
    x2: 216,
    y2: 167.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 191.5,
    x2: 216,
    y2: 191.5,
    stroke: "#E9EAEB"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -120,
    y1: 215.5,
    x2: 216,
    y2: 215.5,
    stroke: "#E9EAEB"
  })), /*#__PURE__*/React.createElement("rect", {
    x: -119.5,
    y: -119.5,
    width: 335,
    height: 335,
    stroke: "#E9EAEB"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5085_866",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(168 168) rotate(90) scale(168 168)"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5085_866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 336,
    height: 336,
    fill: "white",
    transform: "translate(-120 -120)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5085_866"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -120,
    width: 336,
    height: 336,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_5085_866"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -120,
    y: -120,
    width: 336,
    height: 336,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGrid);
export default __webpack_public_path__ + "static/media/background-grid.69074b74f4f92ce894770c080f159d75.svg";
export { ForwardRef as ReactComponent };